import React from 'react'
import { Modal } from 'react-bootstrap'
interface IModalProps {
    show: boolean
    onHide: () => void
    name: string
    price: number
}
export default function IsChashinStatusModal({
    show,
    onHide,
    name,
    price,
}: IModalProps) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-sm px-4">
                <p className=" my-2">
                    حساب دفتری این عضو({name}) صفر نیست ، لطفا برای ادامه فرآیند
                    تسویه و خروج به اپلیکیشن اندروید همیان مراجعه کنید
                </p>
                <hr />
                <p
                    className=" my-2"
                    onClick={() => {
                        onHide()
                    }}
                >
                    بستن
                </p>
            </div>
        </Modal>
    )
}
